import { render } from "./GoogleAddress.vue?vue&type=template&id=5972761c"
import script from "./GoogleAddress.vue?vue&type=script&lang=js"
export * from "./GoogleAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__